export const calculateAdvancedQuery = (selectedItems) => {
  let excludedRule = null;

  let excludedNames = selectedItems.map((x) => x.name);
  //exclude selected
  if (selectedItems.length > 0) {
    excludedRule = {
      field: "name",
      operator: "!=",
      value: JSON.stringify(excludedNames),
      multiple: true,
      dataType: "text",
    };
  }

  let filterModel = null;

  if (excludedRule) {
    filterModel = {
      advancedQuery: {
        filter: {
          rules: [excludedRule],
        },
        filterType: "text",
        type: "contains",
      },
    };

    filterModel.advancedQuery.filter = JSON.stringify(
      filterModel.advancedQuery.filter
    );
  }

  return filterModel;
};
